import React, { useRef, useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useMutation, gql } from '@apollo/client'
import { validateFunc } from '../../../constraints/constraints'
import { saveRiderConfiguration } from '../../../apollo'
import useStyles from '../styles'
import useGlobalStyles from '../../../utils/globalStyles'
import { Box, Typography, Input, Button, Alert } from '@mui/material'

const SAVE_RIDER_CONFIGURATION = gql`
  ${saveRiderConfiguration}
`

function RiderConfiguration(props) {
  const { t } = props
  const formRef = useRef()
  const riderRegistrationUrl = props.riderRegistrationUrl || ''
  const [riderRegistrationUrlError, setRiderRegistrationUrlError] = useState(null)

  const onBlur = (setter, field, state) => {
    setter(!validateFunc({ [field]: state }, field))
  }
  const [mutate, { loading }] = useMutation(SAVE_RIDER_CONFIGURATION)

  const validateInput = () => {
    let riderRegistrationUrlResult = true
    
    const urlValue = formRef.current['input-riderRegistrationUrl'].value.trim()
    if (urlValue) {
      riderRegistrationUrlResult = !validateFunc(
        { riderRegistrationUrl: urlValue },
        'riderRegistrationUrl'
      )
    }
    
    setRiderRegistrationUrlError(riderRegistrationUrlResult)
    return riderRegistrationUrlResult
  }

  const classes = useStyles()
  const globalClasses = useGlobalStyles()
  const [successMessage, setSuccessMessage] = useState('')
  const handleSuccess = message => {
    setSuccessMessage(message)
  }
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSuccessMessage('')
    }, 3000)

    return () => clearTimeout(timeoutId)
  }, [successMessage, setSuccessMessage])
  const [errorMessage, setErrorMessage] = useState('')
  const handleError = error => {
    setErrorMessage('An error occurred while saving configuration.')
    console.error('Mutation error:', error)
  }
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setErrorMessage('')
    }, 3000)

    return () => clearTimeout(timeoutId)
  }, [errorMessage, setErrorMessage])

  return (
    <Box container className={classes.container}>
      <Box className={classes.flexRow}>
        <Box item className={classes.heading}>
          <Typography variant="h6" className={classes.text}>
            {t('Rider Configuration')}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.form}>
        <form ref={formRef}>
          <Box>
            <Typography className={classes.labelText}>
              {t('Rider Registration URL')}
            </Typography>
            <Input
              style={{ marginTop: -1 }}
              id="input-riderRegistrationUrl"
              name="input-riderRegistrationUrl"
              placeholder="https://example.com/rider/register"
              defaultValue={riderRegistrationUrl}
              onBlur={event => {
                onBlur(
                  setRiderRegistrationUrlError,
                  'riderRegistrationUrl',
                  event.target.value.trim()
                )
              }}
              disableUnderline
              className={[
                globalClasses.input,
                riderRegistrationUrlError === false
                  ? globalClasses.inputError
                  : riderRegistrationUrlError === true
                  ? globalClasses.inputSuccess
                  : ''
              ]}
            />
          </Box>
          <Box>
            <Button
              className={globalClasses.button}
              disabled={loading}
              onClick={e => {
                e.preventDefault()
                if (validateInput() && !loading) {
                  mutate({
                    variables: {
                      configurationInput: {
                        riderRegistrationUrl: formRef.current['input-riderRegistrationUrl'].value || null
                      }
                    },
                    onCompleted: data => {
                      handleSuccess('Configuration saved successfully!')
                    },
                    onError: error => {
                      handleError(error)
                    }
                  })
                }
              }}>
              {t('Save')}
            </Button>
          </Box>
          <Box mt={2}>
            {successMessage && (
              <Alert
                className={globalClasses.alertSuccess}
                variant="filled"
                severity="success">
                {successMessage}
              </Alert>
            )}
            {errorMessage && (
              <Alert
                className={globalClasses.alertError}
                variant="filled"
                severity="error">
                {errorMessage}
              </Alert>
            )}
          </Box>
        </form>
      </Box>
    </Box>
  )
}
export default withTranslation()(RiderConfiguration)

